var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1857_148846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 11.2267C22.9815 11.2267 24.9934 9.21477 24.9934 6.73293C24.9934 4.25109 22.9815 2.23917 20.4996 2.23917C18.0178 2.23917 16.0059 4.25109 16.0059 6.73293C16.0059 9.21477 18.0178 11.2267 20.4996 11.2267Z",
    fill: "#F8AD3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9663 28.5764L20.4998 32.0718L6.0332 28.5764C7.01614 26.6595 8.01944 24.3859 8.01944 18.9596C8.01944 12.0669 13.6071 6.47931 20.4998 6.47931C27.3924 6.47931 32.9801 12.067 32.9801 18.9596C32.9801 24.3859 33.9834 26.6595 34.9663 28.5764Z",
    fill: "#F8EA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4997 40.5C23.6908 40.5 26.2777 37.9131 26.2777 34.722C26.2777 31.5309 23.6908 28.9439 20.4997 28.9439C17.3086 28.9439 14.7217 31.5309 14.7217 34.722C14.7217 37.9131 17.3086 40.5 20.4997 40.5Z",
    fill: "#F8EA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5185 32.3685C36.169 30.8037 35.5715 29.7579 34.9666 28.5764H6.03346C5.42863 29.7579 4.83113 30.8037 4.48151 32.3685C4.11523 34.0081 5.35451 35.5671 7.03451 35.5671H33.9656C35.6455 35.5672 36.8848 34.0081 36.5185 32.3685Z",
    fill: "#F8AD3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1857_148846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiche);
export default __webpack_public_path__ + "static/media/notifiche.7ee82cb991d284c4861065fa49d4a4af.svg";
export { ForwardRef as ReactComponent };